import { X } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

/**
 * Modal with the Licitigo blue header bar (white title + white close),
 * matching the legacy Angular dialogs.
 */
export function BrandModal({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
  theme = "blue",
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  theme?: "blue" | "emerald";
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn("gap-0 overflow-hidden p-0", className)}
      >
        <div
          className={cn(
            "flex items-center justify-between px-6 py-4",
            theme === "emerald" ? "bg-emerald-600" : "bg-primary",
          )}
        >
          <DialogTitle className="text-lg font-bold text-primary-foreground">
            {title}
          </DialogTitle>
          <DialogClose className="rounded-md text-primary-foreground/80 transition-colors hover:text-primary-foreground focus:outline-none">
            <X className="size-5" />
            <span className="sr-only">Cerrar</span>
          </DialogClose>
        </div>

        <div className="flex flex-col gap-4 px-6 py-5">
          {description && (
            <DialogDescription className="leading-relaxed">
              {description}
            </DialogDescription>
          )}
          {children}
        </div>

        {footer && (
          <div className="flex justify-end gap-2 border-t px-6 py-4">
            {footer}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
